import React from 'react'
import { Box } from 'mds-web-ui'

export const FlowLogo = ({ color = '#231f20', height = 35, ...props }) => {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        viewBox="0 0 1116.975 263.6"
        aria-label="Flow wordmark"
      >
        <path
          d="M1205.5,117.4,1133,369.9a3.513,3.513,0,0,1-3.3,2.6h-4a3.6,3.6,0,0,1-3.7-2.6L1056.1,147h-.7L989.5,369.9a3.557,3.557,0,0,1-3.7,2.6h-4a3.513,3.513,0,0,1-3.3-2.6L906,117.4c-.7-3.7.7-4.8,4-4.8h8.8a4.683,4.683,0,0,1,4.4,4l61.5,214.5h.7l64.4-218.9c.7-2.2,3.3-3.3,5.5-3.3h.7c2.2,0,4.8,1.1,5.5,3.3l64.8,218.9h.7l61.1-214.5a4.683,4.683,0,0,1,4.4-4h8.8c3.5.1,4.9,1.2,4.2,4.8Zm-516,255.1c-73.2,0-131.8-57.8-131.8-131.4a131.95,131.95,0,1,1,263.9,0C821.6,314.7,763,372.5,689.5,372.5Zm0-247.4c-64,0-115.7,52-115.7,116A115.168,115.168,0,0,0,689.5,356.4c64,0,116-51.2,116-115.3a116.083,116.083,0,0,0-116-116ZM483.8,368.8H354.6a4.867,4.867,0,0,1-4.8-4.8V117.4a4.867,4.867,0,0,1,4.8-4.8h8.1a4.809,4.809,0,0,1,4.4,4.8V353.5H483.9c4.4,0,4.8,2.2,4.8,4.8v6.6c-.2,2.5-2.4,3.9-4.9,3.9ZM240.4,128.4h-134V239.7h116a4.867,4.867,0,0,1,4.8,4.8c0,4,.7,10.6-4.8,10.6h-116L106,364.2c0,2.6-2.2,4.8-5.9,4.8H93.5a4.867,4.867,0,0,1-4.8-4.8V117.4a4.867,4.867,0,0,1,4.8-4.8H240.3a4.867,4.867,0,0,1,4.8,4.8v6.2a4.848,4.848,0,0,1-4.7,4.8Z"
          transform="translate(-88.7 -108.9)"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    </Box>
  )
}
